<template>
  <b-modal
    v-model="showModal"
    size="lg"
    title="Importar CSV"
    centered
    hide-footer
  >
    <div class="col-md-12">
      <div class="row">
        <div class="d-flex flex-column">
          <span
            class="text-center text-primary"
            style="font-size: 40px !important"
            ><i class="mdi mdi-cloud-upload"></i
          ></span>
          <h5 class="mt-3 mb-3 font-bold" style="text-align: justify">
            Realize a importação da planilha em modelo CSV da instituição
            financeira Sicredi para preencher as informações automaticamente.
          </h5>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6">
          <b-form-group label="Instituição Financeira">
            <multiselect
              v-model="selecaoInstituicaoFinanceira"
              :options="instituicaoFinanceiraLkp"
              :disabled="true"
              label="name"
              track-by="name"
            />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <inputCooperado
            ref="inputCooperado"
            :submit="submitCooperado"
            :value="cooperadoParaInput"
            @cooperadoSelecionado="setCooperado"
          />
        </div>
      </div>

      <div class="row mb-2">
        <b-form-group label="Arquivo">
          <input
            ref="fileInput"
            @change="tratarArquivo"
            class="form-control mb-1"
            type="file"
            :state="false"
            :disabled="!cdPessoa"
            accept=".csv,.CSV"
          />
          <small v-if="!cdPessoa" class="text-danger">
            <i class="mdi mdi-alert"></i>
            Selecione um cooperado antes de escolher o arquivo
          </small>
        </b-form-group>
      </div>

      <div class="row">
        <div
          class="col-md-12 col-sm-12 d-flex flex-column flex-md-row gap-2 justify-content-md-center order-1 order-md-2 mb-2 mb-md-0"
        >
          <b-button
            variant="secondary"
            class="mb-2 mb-md-0"
            @click="fecharModal"
            :style="{ width: '105px' }"
          >
            <i class="mdi mdi-arrow-left-circle mx-1"></i>
            <span>Voltar</span>
          </b-button>

          <b-button
            variant="success"
            @click="salvarArquivo"
            :disabled="disabledSalvar || !cdPessoa"
            :style="{ width: '105px' }"
            class="d-flex align-items-center justify-content-center"
          >
            <div v-if="!disabledSalvar">
              <i class="fa fa-solid fa-upload mx-1"></i>
              <span>Importar</span>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <b-spinner small variant="white" v-if="disabledSalvar" />
            </div>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import inputCooperado from "@/components/astec/projetos/lotesImportacao/inputCooperado";

export default {
  mixins: [clienteRuralMixin],
  components: {
    inputCooperado,
    Multiselect
  },

  data() {
    return {
      arquivo: null,
      cdPessoa: null,
      cdPessoaNome: null,
      sqUsuario: null,
      showModal: false,
      disabledSalvar: false,
      submitCooperado: false,
      cooperadoParaInput: null,
      instituicaoFinanceiraLkp: [{ name: "SICREDI [748]", value: 748 }],
      selecaoInstituicaoFinanceira: { name: "SICREDI [748]", value: 748 }
    };
  },

  computed: {
    podeSalvar() {
      return this.cdPessoa && this.arquivo;
    }
  },

  methods: {
    async abrirModal(cooperado) {
      if (!cooperado) {
        this.cdPessoa = null;
        this.cdPessoaNome = null;
        this.cooperadoParaInput = null;
      }
      this.cooperadoParaInput = cooperado;
      if (cooperado) {
        this.cdPessoa = cooperado.value;
        this.cdPessoaNome = cooperado.name;
      }
      this.showModal = true;
      await this.$nextTick();
      await this.$nextTick();

      this.tentarSetarCooperado(cooperado);
    },

    async tentarSetarCooperado(cooperado) {
      if (!cooperado || !this.$refs.inputCooperado) {
        return;
      }

      const tentativas = 5;
      const intervalo = 300;

      for (let i = 0; i < tentativas; i++) {
        try {
          await new Promise(resolve => setTimeout(resolve, intervalo));

          if (this.$refs.inputCooperado.setCooperado) {
            this.$refs.inputCooperado.setCooperado(cooperado);
            break;
          }
        } catch (error) {
          console.log("Erro ao tentar setar o cooperado", error);
        }
      }
    },

    fecharModal() {
      this.showModal = false;
      this.cooperadoParaInput = null;
      this.cdPessoa = null;
      this.cdPessoaNome = null;
      this.arquivo = null;
      this.submitCooperado = false;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },

    async salvarArquivo() {
      this.submitCooperado = true;
      await this.$nextTick();

      if (!this.cdPessoa) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Selecione o cooperado antes de continuar."
        });
        return;
      }

      if (!this.arquivo) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Selecione um arquivo para enviar."
        });
        return;
      }

      const extensaoArquivo = this.arquivo.name
        ? this.arquivo.name
            .substring(this.arquivo.name.lastIndexOf(".") + 1)
            .toLowerCase()
        : "";

      if (extensaoArquivo !== "csv") {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Apenas arquivos CSV são permitidos!"
        });
        return;
      }

      this.disabledSalvar = true;

      try {
        const formData = new FormData();
        formData.append("arquivoImportacao", this.arquivo);
        formData.append("nomeArquivo", this.arquivo.name);
        formData.append("tamanhoArquivo", this.arquivo.size);
        formData.append("cd_bco", this.selecaoInstituicaoFinanceira.value);
        formData.append("cd_pessoa", this.cdPessoa);

        const response = await this.$http.post(
          "/api/astec/projetos/importarProjetos",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );

        const data = response.data.data;

        if (data.status === false) {
          if (data.erros && data.erros.length) {
            this.$emit("errosImportacao", data.erros);
          } else {
            this.planilhaErrorWarning(response);
          }
        } else {
          this.planilhaSuccess(response);
        }
      } catch (error) {
        console.error("Erro ao importar arquivo:", error);
        this.$tools.alerta(
          error.response?.data?.message || "Erro ao importar arquivo",
          "error"
        );
      } finally {
        this.disabledSalvar = false;
        this.arquivo = null;
        if (this.$refs.fileInput) this.$refs.fileInput.value = null;
      }
    },

    tratarArquivo(event) {
      this.arquivo = event.target.files[0];
    },

    setCooperado(cooperado) {
      if (cooperado) {
        this.cdPessoa = cooperado.value;
        this.cdPessoaNome = cooperado.name;
      } else {
        this.cdPessoa = null;
        this.cdPessoaNome = null;
      }
    },

    planilhaSuccess(response) {
      let statusSuccess = response.data.data.status;
      let sqAstecIntegracaoLote = response.data.data.sqAstecIntegracaoLote;
      let qtdProjetos = response.data.data.qtdProjetos;
      if (statusSuccess === true) {
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          html: `O lote <strong>${sqAstecIntegracaoLote}</strong> foi importado com sucesso! Total de projetos importados: <strong>${qtdProjetos}</strong>.`
        }).then(() => {
          localStorage.setItem("sqAstecIntegracaoLote", sqAstecIntegracaoLote);
          this.$router.push("/astec/projetos/lotesImportacao/projetosLote");
        });
      }
    },

    planilhaErrorWarning(response) {
      let statusErrors = response.data.data.status;
      let nomeArquivo = response.data.data.nomeArquivo;
      if (statusErrors === false) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          html: `O arquivo <strong>${nomeArquivo}</strong>, está fora do padrão de importação.
                    Solicite à instituição financeira que corrija o arquivo e forneça uma nova versão conforme o padrão de importação.
                    Depois disso, tente novamente.
                `
        });
      }
    }
  }
};
</script>
